import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileImage,
  faFilePdf,
  faFileExcel,
  faFileWord,
  faFilePowerpoint,
  faFileAudio,
  faFileVideo,
} from '@fortawesome/free-solid-svg-icons';

import { getFileExtension } from './fsObjectUtils';

const DocIcon = ({ doc }) => (
  <FontAwesomeIcon icon={_getFileExtensionIcon(doc)} color={_getColor(doc)} />
);

export default DocIcon;

export const ExtensionMap = {
  '.jpg': faFileImage,
  '.jpeg': faFileImage,
  '.gif': faFileImage,
  '.png': faFileImage,
  '.pdf': faFilePdf,
  '.xlsx': faFileExcel,
  '.xls': faFileExcel,
  '.mov': faFileVideo,
  '.mp4': faFileVideo,
  '.mp3': faFileAudio,
  '.wav': faFileAudio,
  '.doc': faFileWord,
  '.docx': faFileWord,
  '.ppt': faFilePowerpoint,
  '.pptx': faFilePowerpoint,
};

export const ExtensionColorMap = {
  '.jpg': '#5900C9',
  '.jpeg': '#5900C9',
  '.gif': '#5900C9',
  '.png': '#5900C9',
  '.pdf': '#ea1409',
  '.xlsx': '#007229',
  '.xls': '#007229',
  '.mov': '#0085e4',
  '.mp4': '#0085e4',
  '.mp3': '#444444',
  '.wav': '#444444',
  '.doc': '#073885',
  '.docx': '#073885',
  '.ppt': '#E85005',
  '.pptx': '#E85005',
};

export const _getFileExtensionIcon = (doc) => {
  const fileName = doc.name;

  const extension = getFileExtension(fileName);

  return ExtensionMap[extension] || faFileImage;
};

export const _getColor = (doc) => {
  const fileName = doc.name;

  const extension = getFileExtension(fileName);

  return ExtensionColorMap[extension] || '#f4b84b';
};
